import { useSelector } from 'react-redux';
import { selectSnackbarContent } from './snackbar.selectors';

export const useSelectSnackbarContent = () => useSelector(selectSnackbarContent);
